export default __webpack_public_path__ + "static/media/wordhunt.943e82da.png";